import { forwardRef } from 'react';
import { cx } from './cx';

export interface InputProps extends React.ComponentPropsWithoutRef<'input'> {
  leftIcon?: React.ReactNode;
  error?: string;
}

const field =
  'w-full px-4 py-3 rounded-lg border border-neutral-300 dark:border-border-dark bg-white dark:bg-bg-dark-tertiary text-meradio-dark dark:text-text-dark-primary placeholder:text-neutral-400 dark:placeholder:text-text-dark-tertiary focus:outline-none focus:ring-2 focus:ring-meradio-primary focus:border-transparent transition-all duration-200';

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ leftIcon, error, className, ...props }, ref) => (
    <div className="relative">
      {leftIcon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400 dark:text-text-dark-tertiary pointer-events-none">
          {leftIcon}
        </span>
      )}
      <input
        ref={ref}
        aria-invalid={error ? true : undefined}
        className={cx(
          field,
          Boolean(leftIcon) && 'pl-10',
          error && 'border-danger-500 focus:ring-danger-500',
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-danger-600 dark:text-danger-400">{error}</p>
      )}
    </div>
  )
);

Input.displayName = 'Input';

export default Input;
